import { render, staticRenderFns } from "./taskSubmitDialog.vue?vue&type=template&id=4f7445f4&scoped=true"
import script from "./taskSubmitDialog.vue?vue&type=script&lang=js"
export * from "./taskSubmitDialog.vue?vue&type=script&lang=js"
import style0 from "./taskSubmitDialog.vue?vue&type=style&index=0&id=4f7445f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7445f4",
  null
  
)

export default component.exports